<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-expansion-panels multiple v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>Listado de Clientes</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-title>
                              <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Ingresar texto a buscar"
                                single-line
                                hide-details
                              ></v-text-field>
                            </v-card-title>
                            <v-data-table
                              :headers="headers"
                              :items="items"
                              :search="search"
                              :item-class="stockCeroBackground"
                            >
                              <template v-slot:item.created_at="{ item }">
                                {{ formatDate(item.created_at) }}
                              </template>
                            </v-data-table>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </template>

          <v-btn
            fab
            fixed
            bottom
            right
            color="green"
            dark
            @click="exportGoogleContactsCsv()"
          >
            <v-icon>mdi-contacts</v-icon>
          </v-btn>
        </div>
      </template>

      <template>
        <div class="text-center ma-2">
          <v-snackbar
            v-model="snackbar"
            :color="color"
            top
            z-index="500"
          >
            {{ text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'ClientsView',
    components: {
      DefaultLayout
    },
    data () {
      return {
        overlay: false,
        panel: [0],
        findClient: null,
        search: '',
        headers: [
          { text: 'EMAIL', value: 'email'},
          { text: 'NOMBRE', value: 'name' },
          { text: 'APELLIDO', value: 'last_name'},
          { text: 'DNI/CE', value: 'initial_stock' },
          { text: 'CELULAR', value: 'stock' },
          { text: 'CONTACTO REGISTRADO', value: 'contact_registered' },
          { text: 'ESTADO', value: 'status' }
        ],
        items: [],
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      formatDate: function(date) {
        return moment(date).format("DD MMMM YYYY");
      },

      stockCeroBackground: function (item) {
        return item.stock == 0 ? 'row-stock' : ''
      },

      searchClient() {
        this.overlay = true;
        const params = {};

        if (this.findClient && this.findClient.trim() !== '') {
          params.q = this.findClient;
        }

        axios.get(process.env.DINO.PATH.SEARCH_CLIENT, { params })
        .then(response => {
          if (response.data.length == 0) {
            this.showMessage(`No se encontró cliente con estos datos de búsqueda "${this.findClient}"`, 'deep-purple accent-4');
          } else {
            this.items = response.data;
          }
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      exportGoogleContactsCsv() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.DOMWLOAD_CLIENTS_GOOGLE_CONTACTS_CSV, {
          responseType: 'blob',
          headers: {
            'Content-Type': 'text/xls'
          }
        })
        .then(response => {
          const fileURL = URL.createObjectURL(response.data);
          let a = document.createElement('a')
          a.setAttribute('href', fileURL)
          a.setAttribute('download', response.headers['name-file'])
          a.click()
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

    },

    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.searchClient();
    }
  }
</script>
<style>
  .row-stock {
    background-color: #ff000040
  }
</style>



// WEBPACK FOOTER //
// src/views/client/Clients.vue